import { render } from "./OrgsView.vue?vue&type=template&id=7eb8799a"
import script from "./OrgsView.vue?vue&type=script&lang=js"
export * from "./OrgsView.vue?vue&type=script&lang=js"

import "./OrgsView.vue?vue&type=style&index=0&id=7eb8799a&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__